import { render } from "./OrganizationStatistics.vue?vue&type=template&id=3ec1e0cb&scoped=true"
import script from "./OrganizationStatistics.vue?vue&type=script&lang=js"
export * from "./OrganizationStatistics.vue?vue&type=script&lang=js"

import "./OrganizationStatistics.vue?vue&type=style&index=0&id=3ec1e0cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec1e0cb"]])

export default __exports__